// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9979dbb7","703":"6e945b27","787":"4afabf7e"}[chunkId] + ".chunk.js";
};